import { render, staticRenderFns } from "./cloudPhone.vue?vue&type=template&id=49a28938&scoped=true"
import script from "./cloudPhone.vue?vue&type=script&lang=js"
export * from "./cloudPhone.vue?vue&type=script&lang=js"
import style0 from "./cloudPhone.vue?vue&type=style&index=0&id=49a28938&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a28938",
  null
  
)

export default component.exports